import type { IconData } from '@stacksjs/iconify-core'

export const twitch: IconData = {
  "body": "<g fill=\"currentColor\"><path d=\"M1.25 0L0 3.75V17.5h5V20h2.5l2.5-2.5h3.75l5-5.325V0zM17.5 11.25L14 15H9.568l-2.693 1.959V15H2.5V1.25h15z\"/><path d=\"M8.75 5H10v5H8.75zm3.75 0h1.25v5H12.5z\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default twitch
